import b from 'b_';
import React from 'react';
import { useMedia } from 'react-use';

import QuizStudentWrapper, { QUIZ_STUDENT_THEME } from '../__wrapper/quiz-student__wrapper';
import { UI_KIT_HEADER_TYPOGRAPHY, UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import { H2, H4 } from '../../header-text/header-text';
import { CARD_COLORS, Question } from '../../quiz/typings';
import { MEDIA_QUERY_MOBILE_M } from '../../../utils/von-dyck-media-queries';
import Text from '../../text/text';

interface Props {
    name: string;
    onAnswerClick: (answerIndex: number) => void;
    question: Question | null;
    questionIndex: number | null;
    questionsCount: number | null;
}

export const QuizStudentQuestion = (props: Props) => {
    const { name, onAnswerClick, question, questionIndex = null, questionsCount = 0 } = props;
    const isSmallScreen = useMedia(MEDIA_QUERY_MOBILE_M);

    if (!question) {
        return null;
    }

    const content = (
        <>
            {questionIndex !== null && (
                <div className="quiz-student__question">
                    <Text
                        id="quiz.questionsCounter"
                        typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLMedium}
                        values={{ index: questionIndex + 1, length: questionsCount }}
                    />
                </div>
            )}
            <H4
                mix={b('quiz-student__section-title', { question: true })}
                typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}
            >
                {question.title}
            </H4>
            <div className={b('quiz-student__answers', { small: isSmallScreen })}>
                {question.answers.map((answer, answerIndex) => {
                    const color = CARD_COLORS[answerIndex];

                    return (
                        <div
                            className={b('quiz-student__answer', { color })}
                            key={answer.value}
                            onClick={() => {
                                onAnswerClick(answerIndex);
                            }}
                        >
                            <H2 typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}>{answer.value}</H2>
                        </div>
                    );
                })}
            </div>
        </>
    );

    return (
        <QuizStudentWrapper name={name} questionIndex={questionIndex} theme={QUIZ_STUDENT_THEME.QUESTION}>
            {isSmallScreen ? content : <div className={b('quiz-student__section')}>{content}</div>}
        </QuizStudentWrapper>
    );
};
